import Lobby from './Lobby';
import Manage from './Manage';
import Puzzle from './Puzzle';

export default {
  Lobby,
  Manage,
  Puzzle,
};
